import type { ReactNode } from 'react'
import type { FaqItem } from '@/config/marketing-content/types'
import { HeroKicker } from '@/components/marketing/hero-kicker'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { cn } from '@/lib/utils'

export function FaqSection({
  eyebrow,
  title,
  lead,
  items,
  variant = 'default',
  className,
}: {
  eyebrow?: string
  title: string
  lead?: ReactNode
  items: FaqItem[]
  variant?: 'default' | 'cards'
  className?: string
}) {
  return (
    <section className={cn('marketing-section', className)}>
      <div className="marketing-container">
        <div className="faq-section">
          <div className="space-y-3 text-center">
            {eyebrow ? <HeroKicker>{eyebrow}</HeroKicker> : null}
            <h2 className="marketing-h2">{title}</h2>
            {lead ? <p className="marketing-lead marketing-lead--center">{lead}</p> : null}
          </div>
          <Accordion
            type="single"
            collapsible
            className={cn('w-full', variant === 'cards' && 'faq-accordion--cards')}
          >
          {items.map((item, index) => (
            <AccordionItem
              key={item.question}
              value={`item-${index}`}
              className={variant === 'cards' ? 'faq-accordion__item border-b-0' : undefined}
            >
              <AccordionTrigger
                className={cn(
                  variant === 'cards' &&
                    'faq-accordion__trigger hover:text-white data-[state=open]:text-white'
                )}
              >
                {item.question}
              </AccordionTrigger>
              <AccordionContent
                className={cn(
                  variant === 'cards' &&
                    'faq-accordion__content pt-0 pb-4 text-[var(--faq-answer-color)]'
                )}
              >
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        </div>
      </div>
    </section>
  )
}
